import React, { useEffect, useMemo, useState } from 'react';
import { getMonth, getYear } from 'date-fns';

import { Icons } from '@icons/icons';

import { getYearOptions } from '@utils/common';

import { TSelectOptionType } from '../../Select/Select.types';
import { ICustomHeaderProps } from './CustomHeader.types';

import { monthsOptions } from './constants';

import Select from '../../Select';

import './CustomHeader.scss';

const CustomHeader: React.FC<ICustomHeaderProps> = ({
	changeMonth,
	changeYear,
	date,
	decreaseMonth,
	increaseMonth,
}) => {
	const yearOptions = useMemo(() => getYearOptions(), []);

	const [selectedMonthOption, setSelectedMonthOption] = useState<TSelectOptionType | undefined>();
	const [selectedYear, setSelectedYear] = useState<TSelectOptionType | undefined>();

	useEffect(() => {
		setSelectedMonthOption(monthsOptions.find(month => month.value === getMonth(date)));
		setSelectedYear(yearOptions.find((year: TSelectOptionType) => year?.value === getYear(date)));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [date]);

	const handleMonthChange = (month: TSelectOptionType) => month && changeMonth(month.value as number);

	const handleYearChange = (year: TSelectOptionType) => year && changeYear(year.value as number);

	return (
		<div className='f5gCustomHeaderContainer'>
			<div className='f5gCustomHeaderDropdowns'>
				<Select
					className='f5gCustomHeaderMonthSelect'
					handleChange={handleMonthChange as any}
					isWithoutUseForms
					name='month'
					options={monthsOptions}
					value={selectedMonthOption}
				/>
				<Select
					className='f5gCustomHeaderYearSelect'
					handleChange={handleYearChange as any}
					isWithoutUseForms
					name='year'
					options={yearOptions}
					value={selectedYear}
				/>
			</div>
			<div className='f5gCustomHeaderNavigation'>
				<span onClick={decreaseMonth}>{Icons.arrowUp()}</span>
				<span onClick={increaseMonth}>{Icons.arrowDown()}</span>
			</div>
		</div>
	);
};

export default CustomHeader;
